<template>
  <UCard variant="outline" :ui="{
    root: 'ring-0'
  }">
    <template #header>
      <div class="flex items-center justify-between">
        <h3 class="text-lg font-medium text-default">{{ $t('Filter') }}</h3>

        <UButton variant="ghost" size="xs" color="primary" @click="clearAll" v-if="hasActiveFilters">
          {{ $t('Clear All') }}
        </UButton>
      </div>
    </template>

    <div class="space-y-2 space-x-2">
      <!-- Price filter -->

      <div class="text-muted" v-if="!hasActiveFilters">
        {{ $t('No active filters') }}
      </div>

      <UBadge v-if="priceFilterApplied" color="primary" variant="subtle">
        {{ filters.minPrice || 0 }} - {{ filters.maxPrice || '∞' }} {{ currencyStore.currency }}
        <button @click="removePriceFilter" class="ml-1 hover:text-red-500">
          <Icon name="i-heroicons-x-mark" class="w-3 h-3" />
        </button>
      </UBadge>

      <!-- Category filters -->
      <UBadge v-for="categoryId in filters.categories || []" :key="categoryId" color="primary" variant="subtle">
        {{ getCategoryName(categoryId) }}
        <button @click="removeCategory(categoryId)" class="ml-1 hover:text-red-500">
          <Icon name="i-heroicons-x-mark" class="w-3 h-3" />
        </button>
      </UBadge>

      <!-- <UBadge 
      v-for="badge in filters.features || []"
      :key="badge"
      color="primary" 
      variant="subtle"
    >
      {{ badge }}
      <button @click="removeBadge(badge)" class="ml-1 hover:text-red-500">
        <Icon name="i-heroicons-x-mark" class="w-3 h-3" />
      </button>
    </UBadge> -->

      <!-- <UBadge 
      v-for="rating in filters.ratings || []"
      :key="rating"
      color="primary" 
      variant="subtle"
    >
      {{ rating }}+ stars
      <button @click="removeRating(rating)" class="ml-1 hover:text-red-500">
        <Icon name="i-heroicons-x-mark" class="w-3 h-3" />
      </button>
    </UBadge> -->


    </div>
  </UCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ProductFilter } from '~/types';

const {
  filters,
  catalogMinPrice,
  catalogMaxPrice
} = defineProps<{
  filters: ProductFilter,
  catalogMinPrice?: number,
  catalogMaxPrice?: number,
}>()

const emit = defineEmits<{
  (e: 'update:filters', v: any): void
  (e: 'clear'): void
}>()

const priceFilterApplied = computed(() => {
  if (typeof catalogMinPrice === 'number' && typeof filters.minPrice === 'number' && filters.minPrice > catalogMinPrice) {
    return true
  }

  if (typeof catalogMaxPrice === 'number' && typeof filters.maxPrice === 'number' && filters.maxPrice < catalogMaxPrice) {
    return true
  }

  return false
})

const hasActiveFilters = computed(() => {
  if (priceFilterApplied.value) {
    return true
  }

  if (filters.categories && filters.categories.length > 0) {
    return true
  }

  // if (filters.features && filters.features.length > 0) {
  //   return true
  // }

  // if (filters.ratings && filters.ratings.length > 0) {
  //   return true
  // }
})

const categoryStore = useCategoryStore()

function getCategoryName(categoryId: number) {
  const category = categoryStore.categories.find(c => c.id === categoryId)
  return category ? category.name : categoryId
}

function removePriceFilter() {
  emit('update:filters', {
    ...filters,
    minPrice: catalogMinPrice || 0,
    maxPrice: catalogMaxPrice || 500
  })
}

function removeCategory(categoryId: number) {
  emit('update:filters', {
    ...filters,
    categories: filters.categories?.filter((c: number) => c !== categoryId)
  })
}

// function removeBadge(badge: string) {
//   emit('update:filters', {
//     ...filters,
//     features: filters.features.filter((b: string) => b !== badge)
//   })
// }

// function removeRating(rating: number) {
//   emit('update:filters', {
//     ...filters,
//     ratings: filters.ratings.filter((r: number) => r !== rating)
//   })
// }

function clearAll() {
  emit('clear')
}

const currencyStore = useCurrencyStore()
</script>
